export const AWAITING_PAYMENT = 'AwaitingPayment';
export const ON_HOLD = 'OnHold';
export const AWAITING_SHIPMENT = 'AwaitingShipment';
export const PENDING_FULFILLMENT = 'PendingFulfillment';
export const REJECTED_FULFILLMENT = 'RejectedFulfillment';
export const PENDING_PICKUP = 'PendingPickup';
export const SHIPPED = 'Shipped';
export const CANCELLED = 'Cancelled';

const statusMap = {
  'awaiting-payment': AWAITING_PAYMENT,
  'on-hold': ON_HOLD,
  'awaiting-shipment': AWAITING_SHIPMENT,
  'pending-fulfillment': PENDING_FULFILLMENT,
  'rejected-fulfillment': REJECTED_FULFILLMENT,
  'pending-pickup': PENDING_PICKUP,
  shipped: SHIPPED,
  cancelled: CANCELLED,
};

export const getOrderStatusFromViewName = (viewId) => {
  return statusMap[viewId];
};
